<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_MARKER_PRODUCTS_ID'
        )
      }"
    >
      <!--<select
        v-model="$parent.project.UF_MARKER_PRODUCTS_ID"
        class="sel-dropdown i-main-style i-wid-29"
      >
        <option
          v-for="item in $parent.directory.marker_products"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.NAME"
          v-if="
            $parent.project.UF_SETTING.VERSION_MARKER_PRODUCTS == item.VERSION
          "
        ></option>
      </select>-->

      <Multiselect
        label="NAME"
        class="i-main-style i-wid-50 multiselect-filter-project-register multiselect-multiline"
        :limit="1"
        :multiple="false"
        :limitText="filterItemText"
        track-by="ID"
        v-model="$parent.project.UF_MARKER_PRODUCTS_ID_ARR"
        :disabled="$parent.$parent.projectDisabled"
        :options="filterMarkerList"
        placeholder
        @input="changeMarker"
      />

      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_MARKER_PRODUCTS_ID"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "uf_marker_products",
  components: { Multiselect },
  computed: {
    filterMarkerList() {
      let version =
        parseInt(this.$parent.project.UF_SETTING.VERSION_MARKER_PRODUCTS) > 0
          ? parseInt(this.$parent.project.UF_SETTING.VERSION_MARKER_PRODUCTS)
          : 1;

      let t = this.$parent.directory.marker_products.filter(
        c => c.VERSION === version
      );
      if (t.length > 0) {
        return t;
      }

      return [];
    }
  },
  methods: {
    filterItemText(count) {
      console.log(count);
      return ``;
    },
    changeMarker() {
      console.log(this.$parent.project.UF_MARKER_PRODUCTS_ID_ARR.ID);
      this.$parent.project.UF_MARKER_PRODUCTS_ID = this.$parent.project.UF_MARKER_PRODUCTS_ID_ARR.ID;
    }
  }
};
</script>

<style scoped></style>
